import React from "react";
import { Layout, Badge, Icon } from "antd";
import { useSelector } from "react-redux";

import UserMenu from "../../../containers/UserMenu";
import FavoriteCount from "../../../containers/FavoriteCount";
import styles from "./webHeader.scss";
import { PageRoute } from "../../../models";
import HeaderLogo from "../../HeaderLogo";
import SearchBar from "../../../containers/HomePage/SearchBar";
import { SignInButton } from "../../../containers/UserMenu/SignInButton";
import { getIconUrl } from "../../../services/asset";
import { MessagesLink } from "../MessagesLink/MessagesLink";
import { Button } from "../../Button/Button";
import { Link } from "../../Link/Link";

const WebHeader = (props: any) => {
  const {
    showLogoAndSearchBar,
    onLogoClick,
    onSubmitAdClick,
    scrolling,
    transparent,
    user
  } = props;


  const renderSearchBar = (mobile: any) => {
    if (!showLogoAndSearchBar) {
      return null;
    }

    return (
      <SearchBar
        isMobile={mobile}
        iconOnly={mobile}
        className={styles.searchBar}
      />
    );
  };

  const renderLogo = (mobile: any) => {
    if (mobile || showLogoAndSearchBar) {
      return (
        <div
          className={
            !showLogoAndSearchBar ? `child-center ${styles.logoContainer}` : ""
          }
        >
          <HeaderLogo className={styles.logo} onClick={onLogoClick} />
        </div>
      );
    }

    return null;
  };

  const renderSubmitAdButton = () => {
    // hide if user is already at post ad page.
    if (window.location.pathname.includes(PageRoute.postAd)) {
      return null;
    }

    return (
      <Button
        className={scrolling ? styles.submitAdScrolling : styles.submitAd}
        type="primary"
        onClick={onSubmitAdClick}
      >
        <img
          alt={"Predaj oglas"}
          src={getIconUrl("plus_white.svg")}
          className={styles.submitAdIcon}
        />
        {"Predaj oglas"}
      </Button>
    );
  };

  return (
    <Layout.Header className={styles.headerContainer}>
      <div
        style={transparent ? { backgroundColor: "transparent" } : null}
        className={scrolling ? styles.headerScrolling : styles.header}
      >
        <div className={styles.leftMenu}>
          {!showLogoAndSearchBar && (
            <Link href="https://www.index.hr/" target="_blank" rel="noopener noreferrer nofollow">
              <img
                alt="Index.hr"
                src={getIconUrl("indexhr-crni.svg")}
                className={styles.indexhrLogo}
              />
            </Link>
          )}
          {renderLogo(false)}
          {renderSearchBar(false)}
        </div>
        <div className={styles.rightMenu}>
          <div className={styles.favoriteCount}>
            <FavoriteCount mobile={false} />
          </div>
          {user && (
            <MessagesLink />
          )}

          <div className={styles.user}>
            {user ? null : <SignInButton />}
            <UserMenu mobile={false} />
          </div>
          {renderSubmitAdButton()}

        </div>
      </div>
    </Layout.Header>
  );
}

WebHeader.defaultProps = {
  transparent: false,
  showLogoAndSearchBar: true,
  scrolling: false,
  user: null
};

export default WebHeader;



// WEBPACK FOOTER //
// ./src/components/Header/WebHeader/index.tsx